import createTableStore from "ds/components/Table/store/useTableStore";

import {
  MODULE_VERSION_EXAMPLES_TABLE_COLUMNS_CONFIG,
  MODULE_VERSION_EXAMPLES_TABLE_STORAGE_KEY,
} from "./constants";

const useModuleVersionExamplesTableStore = createTableStore({
  storageKey: MODULE_VERSION_EXAMPLES_TABLE_STORAGE_KEY,
  config: MODULE_VERSION_EXAMPLES_TABLE_COLUMNS_CONFIG,
});

export default useModuleVersionExamplesTableStore;
